module.exports = __webpack_public_path__ + "img/247.48feedf1.png";